import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import TableChartIcon from "@mui/icons-material/TableChart";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

import { removeAdminToken } from "../../../utils/auth";

import "./navbar.scss";

function Navbar() {
  const navigate = useNavigate();

  const [toggle, setToggle] = useState(false);

  const handleToggle = () => {
    setToggle((prev) => {
      const nextState = !prev;

      document.body.style.overflow = nextState ? "hidden" : "auto";

      return nextState;
    });
  };

  const closeMenu = () => {
    setToggle(false);
    document.body.style.overflow = "auto";
  };

  const handleLogout = async () => {
    try {
      await removeAdminToken();

      localStorage.clear();
      sessionStorage.clear();

      navigate("/admin/login", { replace: true });

      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <header className="navbar">
      {/* =====================================================
          TOP NAVBAR
          ===================================================== */}

      <div className="navbar_main">
        {/* Logo / Brand */}

        <div className="menu_logo">
          <Link to="/" onClick={closeMenu}>
            <div className="navbar-brand">
              <span className="navbar-brand-mark">F</span>

              <div className="navbar-brand-text">
                <strong>FARMOLOGY</strong>
                <span>SMART AGRICULTURE</span>
              </div>
            </div>
          </Link>
        </div>

        {/* Right Side */}

        <div className="item_lists">
          <Link
            to="/admin/admin-profile"
            className="navbar-profile-link"
            onClick={closeMenu}
          >
            <div className="item">
              <div className="navbar-profile-info">
                <span>ADMIN</span>
                <strong>Profile</strong>
              </div>

              <img
                className="admin_pic"
                src="/Images/defaultProfileDp.png"
                alt="Admin profile"
              />
            </div>
          </Link>

          <button
            type="button"
            className="navbar-mobile-menu"
            onClick={handleToggle}
            aria-label={toggle ? "Close menu" : "Open menu"}
            aria-expanded={toggle}
          >
            {toggle ? "✕" : "☰"}
          </button>
        </div>
      </div>

      {/* =====================================================
          RESPONSIVE MENU
          ===================================================== */}

      {toggle && (
        <div className="res_navbar">
          <div className="res_nav_menu">
            <div className="res_nav_menuu">
              <div className="links">
                <ul>
                  {/* Main */}

                  <p className="spann">MAIN</p>

                  <Link
                    to="/admin/dashboard"
                    onClick={closeMenu}
                    className="nav-link"
                  >
                    <li>
                      <DashboardIcon className="icon" />
                      <span>Dashboard</span>
                    </li>
                  </Link>

                  {/* Lists */}

                  <p className="spann">LISTS</p>

                  <Link
                    to="/admin/all-admins"
                    onClick={closeMenu}
                    className="nav-link"
                  >
                    <li>
                      <PersonIcon className="icon" />
                      <span>Admins</span>
                    </li>
                  </Link>

                  <Link
                    to="/admin/push-notification"
                    onClick={closeMenu}
                    className="nav-link"
                  >
                    <li>
                      <FontAwesomeIcon icon={faBell} className="icon" />
                      <span>Push Notification</span>
                    </li>
                  </Link>

                  <Link
                    to="/admin/recommended-products"
                    onClick={closeMenu}
                    className="nav-link"
                  >
                    <li>
                      <TableChartIcon className="icon" />
                      <span>Recommended Products</span>
                    </li>
                  </Link>

                  <Link
                    to="/admin/crop-stage"
                    onClick={closeMenu}
                    className="nav-link"
                  >
                    <li>
                      <NotificationsNoneIcon className="icon" />
                      <span>Crop Stage</span>
                    </li>
                  </Link>

                  {/* Settings */}

                  <p className="spann">SETTINGS</p>

                  <li
                    className="logout-item"
                    onClick={handleLogout}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        handleLogout();
                      }
                    }}
                  >
                    <LogoutIcon className="icon" />
                    <span>Log Out</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;
